<template>
  <div class="profile_wrapper">
    <UserInfo :users-list="usersList"
              :user_name="user_name"
              :user_rating="user_rating"
              :following="following"
              :followers="followers"
              :on-create-user-follow="onCreateUserFollow"
              :on-delete-user-follow="onDeleteUserFollow"
              @loadUsersList="getUserslist"
              @openSnackbar="openSnackbar"/>
    <UserVisits :on-get-restaurant-visits="onGetRestaurantVisits"
                :user-token="this.routeProps.token"
                :visited-restaurants="visitedRestaurants"/>

    <UserFavorites :favorites_list="favorites_list"
                   :restaurants-list="restaurantsList"
                   :on-create-favorite-list="onCreateFavoriteList"
                   :on-delete-favorite-list="onDeleteFavoriteList"
                   :on-update-favorite-list="onUpdateFavoriteList"
                   :on-add-restaurant-to-list="onAddRestaurantToList"
                   :on-delete-restaurant-from-list="onDeleteRestaurantFromList"
                   @openSnackbar="openSnackbar"/>

    <info-snackbar ref="snackbar" :type="snackbar_type" :message="snackbar_message"/>
  </div>
</template>

<script>
import Api from "@/services/api";
import UserInfo from "@/components/User/UserInfo";
import UserVisits from "@/components/User/UserVisits";
import UserFavorites from "@/components/User/UserFavorites";
import InfoSnackbar from "@/components/InfoSnackbar";

export default {
  name: "User",
  components: {
    InfoSnackbar,
    UserInfo,
    UserVisits,
    UserFavorites
  },

  data() {
    return {
      usersList: [],
      user: "",
      user_name: "",
      user_email: "",
      user_rating: "",
      favorites_list: "",
      restaurantsList: [],
      restaurants: "",
      visits: "",
      visitedRestaurantsIds: [],
      visitedRestaurants: [],
      visitsByRestaurant: [],
      followers: [],
      following: [],

      snackbar_message: "",
      snackbar_type: ""
    }
  },
  props: ['routeProps'],

  computed: {
    visits_items() {
      return this.visits['items']
    }
  },

  methods: {
    openSnackbar(payload) {
      this.snackbar_message = payload.message
      this.snackbar_type = payload.type
      this.$refs['snackbar'].openSnackbar()
    },

    openSnackbarError() {
      this.snackbar_message = "An error occured"
      this.snackbar_type = "error"
      this.$refs['snackbar'].openSnackbar()
    },

    buildVisitedRestaurantsIdsSet() {
      this.visitedRestaurantsIds = []
      this.visits_items.forEach(visit => {
        this.visitedRestaurantsIds.push(visit.restaurant_id)
      })
      this.visitedRestaurantsIds = [...new Set(this.visitedRestaurantsIds)]
    },

    buildUserFavoritesLists() {
      this.favorites_list = this.favorites_list.items
    },

    async buildVisitedRestaurantsSet() {
      this.$emit('checkToken')
      this.visitedRestaurants = []
      for (const restau_id of this.visitedRestaurantsIds) {
        this.visitedRestaurants.push(await this.api.getRestaurantById(restau_id))
      }
    },

    async getUserslist() {
      this.$emit('checkToken')
      this.usersList = await this.api.getUsers(this.routeProps)
      this.usersList = this.usersList.items
    },

    async onGetRestaurantVisits(restaurant_id) {
      this.$emit('checkToken')
      return await this.api.getRestaurantVisits(this.routeProps, restaurant_id)
    },

    async onCreateFavoriteList(name) {
      this.$emit('checkToken')
      let response = await this.api.createFavoriteList(name, this.routeProps)

      if (response !== "") {
        this.snackbar_message = "List created successfully"
        this.snackbar_type = "success"
        this.$refs['snackbar'].openSnackbar()
      } else {
        this.openSnackbarError()
      }
    },

    async onDeleteFavoriteList(favorite_id) {
      this.$emit('checkToken')
      let response = await this.api.deleteFavoriteList(favorite_id, this.routeProps)

      if (response !== "") {
        this.snackbar_message = "List deleted successfully"
        this.snackbar_type = "success"
        this.$refs['snackbar'].openSnackbar()
      } else {
        this.openSnackbarError()
      }
    },

    async onUpdateFavoriteList(favorite_id, favorite_name) {
      this.$emit('checkToken')
      let response = await this.api.updateFavoriteList(favorite_id, favorite_name, this.routeProps)
      if (response !== "") {
        this.snackbar_message = "List updated successfully"
        this.snackbar_type = "success"
        this.$refs['snackbar'].openSnackbar()
      } else {
        this.openSnackbarError()
      }
    },

    async onAddRestaurantToList(favorite_id, restaurant_id) {
      this.$emit('checkToken')
      let response = await this.api.addRestaurantToFavoriteList(favorite_id, restaurant_id, this.routeProps);
      if (response !== "") {
        this.snackbar_message = "Restaurant added successfully"
        this.snackbar_type = "success"
        this.$refs['snackbar'].openSnackbar()
      } else {
        this.openSnackbarError()
      }
    },

    async onDeleteRestaurantFromList(favorite_id, restaurant_id) {
      this.$emit('checkToken')
      let response = await this.api.deleteRestaurantFromFavoriteList(favorite_id, restaurant_id, this.routeProps)
      if (response !== "") {
        this.snackbar_message = "Restaurant deleted successfully"
        this.snackbar_type = "success"
        this.$refs['snackbar'].openSnackbar()
      } else {
        this.openSnackbarError()
      }
    },

    async onCreateUserFollow(user_id) {
      this.$emit('checkToken')
      await this.api.createUserFollower(user_id, this.routeProps)
    },

    async onDeleteUserFollow(user_id) {
      this.$emit('checkToken')
      await this.api.deleteUserFollow(user_id, this.routeProps)
    },

    async loadAll() {
      await this.getUserslist()

      this.user = await this.api.getUser(this.routeProps)
      this.user_name = this.user.name.replaceAll("\"", "");
      this.user_email = this.user.email.replaceAll("\"", "");
      this.user_rating = this.user.rating;

      this.favorites_list = await this.api.getUserFavoritesLists(this.routeProps);

      this.followers = this.user.followers;
      this.following = this.user.following;

      this.restaurantsList = await this.api.getRestaurants()
      this.restaurantsList = this.restaurantsList['items']
      this.visits = await this.api.getRestaurantsVisits(this.routeProps);

      this.buildUserFavoritesLists()
      this.buildVisitedRestaurantsIdsSet();
      await this.buildVisitedRestaurantsSet();
      console.clear()
    }
  },

  async created() {
    this.api = new Api()
    this.$emit('checkToken')

    await this.loadAll()
    this.$eventHub.$on('reloadAll', this.loadAll);
  },

  beforeDestroy() {
    this.$eventHub.$off('reloadAll');
  },
}

</script>

<style scoped>
.profile_wrapper {
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
